import Template from "./template";

const templates = [
  {
    id: "default",
    label: "Default Template",
    template: Template
  }
];

export default templates;
